import { render, staticRenderFns } from "./crmchannelinfo-add-or-update.vue?vue&type=template&id=746e201d&scoped=true&"
import script from "./crmchannelinfo-add-or-update.vue?vue&type=script&lang=js&"
export * from "./crmchannelinfo-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./crmchannelinfo-add-or-update.vue?vue&type=style&index=0&id=746e201d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e201d",
  null
  
)

export default component.exports